import { useLocation, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

export const PresaVisioneGuard = ({ children }) => {
  const roles = useSelector((state) => state.role);
  const datiUtente = useSelector((state) => state.presaVisione);
  const location = useLocation();
  if (roles.selected && roles.selected === 'CITTADINO' && roles.authorities && !datiUtente.presaVisione && location.pathname !== '/presa-visione') {
    return <Navigate to='/presa-visione' state={{ from: location }} replace />;
  }
  return children;
};
